import * as React from 'react';

import { Paper, Typography } from '@material-ui/core';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';

import { logEvent } from '@api/analytics';
import Link from '@components/Link';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3)
    },
    paper: {
      marginTop: theme.spacing(6),
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      maxWidth: theme.breakpoints.values.sm,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4)
      }
    },
    purchaseButton: {
      marginTop: theme.spacing(2)
    }
  });

type IProps = WithStyles<typeof styles> & { lieuucationId: string };

export const VerifyForm: React.FC<IProps> = ({ classes }) => {
  React.useEffect(() => {
    logEvent({
      category: 'User',
      action: 'Viewed Verification Page'
    });
  }, []);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Typography id="verify-email-header" variant="h4" gutterBottom>
          Verify your email
        </Typography>
        <Typography id="verify-email-warning-text" variant="body1" gutterBottom>
          {' You will need to verify your email in order to view reports.'}
          {
            ' Please check your email and confirm your account before proceeding.'
          }
        </Typography>
        <Typography variant="body1">
          {' Refresh this page once your account is verified.'}
          {' If you are having trouble, please visit our '}
          <Link href="/support">support</Link>
          {' page.'}
        </Typography>
      </Paper>
    </div>
  );
};

export default withStyles(styles)(VerifyForm);
